import { render } from "./TenantManager.vue?vue&type=template&id=3f1dad3f"
import script from "./TenantManager.vue?vue&type=script&lang=js"
export * from "./TenantManager.vue?vue&type=script&lang=js"
script.render = render

export default script